import {
  ISearchParams,
  IStoreListingModel,
  StoreListingModel,
} from '@common/models';
import { SearchService } from '@common/services/searchService';
import { StandardSearchStore } from '@common/stores';

export interface IStoreSearchFilter {
  name: string;
  city: string;
  state: string;
  zipCode: string;
  isHospital?: boolean;
  onlyHCL: boolean;
}

export const defaultStoreSearchFilter: IStoreSearchFilter = {
  name: '',
  city: '',
  state: '',
  zipCode: '',
  isHospital: undefined,
  onlyHCL: true,
};

const defaultSearchParams: ISearchParams = {
  skip: 0,
  top: 20,
  orderby: [
    { field: 'storeId', dir: 'asc' },
    { field: 'marketId', dir: 'asc' },
  ],
  search: undefined,
};

export class StoreSearchStore extends StandardSearchStore<
  IStoreSearchFilter,
  IStoreListingModel,
  StoreListingModel
> {
  constructor() {
    super(
      {
        endpointUrl: SearchService.SearchEndPoints.stores,
        defaultSearchParams: { ...defaultSearchParams },
        defaultSearchFilter: { ...defaultStoreSearchFilter },
      },
      (result: IStoreListingModel) => {
        return new StoreListingModel(result);
      },
    );
  }
}
